import { reactive, ref } from 'vue';
import { useStore } from "vuex";

export default function useVFLogin( router ) {
    const username = ref('');
    const password = ref('');
    const valid = ref(true);
    const errors = reactive({});
    const store = useStore();

    const onLogin = async () => {
        const isValid = onCheckValues();
        if (!isValid) return;
        await store.dispatch('auth/login', { "username": username.value, "password": password.value }).
        then(response => {
            if (response.ok) {
                router.push({ name: 'Inicio' })
            } else {
                errors.username = 'Usuario inválido';
                errors.password = 'Password inválido';
            }
        })
        .catch(error => {
            errors.username = 'Usuario inválido';
            errors.password = 'Password inválido';
            errors.errors = error;
        }
        );

        onClearValues();
        router.push({ name: 'Inicio' });
    };

    const onCheckValues = () => {
        onClearErrors();
        let success = true;

        if (username.value.trim() === '') {
            errors.username = 'Usuario inválido';
            success = false;
        }

        const minLength = 8;
        valid.value = ((password.value.trim() !== '') && (password.value.length >= minLength));
        if (!valid.value) {
            errors.password = 'Password inválido';
            success = false;
        }

        return success;
    };

    const onClearValues = () => {
        username.value = '';
        password.value = '';
    };

    const onClearErrors = () => {
        errors.username = '';
        errors.password = '';
    }

    const onClearLocalStorageData = () => {
        localStorage.removeItem('EXC-token');
        localStorage.removeItem('EXC-refreshToken');
        localStorage.removeItem('EXC-clientName');
        localStorage.removeItem('EXC-urlBack');
    }

    return {
        errors,
        username,
        password,
        onClearLocalStorageData,
        onLogin
    };
}
